import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

interface PaymentRequest {
  amount: number;
  merchantReference: string;
  returnUrl: string;
  customerFirstName: string;
  customerLastName: string;
  customerEmail: string;
  customerPhone: string;
  customerAddress?: string;
  lineItems: {
    name: string;
    unitPrice: number;
    quantity: number;
  }[];
  payment_method_key: string;
  userId?: string;
}

export async function createEstoPayment(paymentData: PaymentRequest, isTest = false, selectedPayment = 'esto') {
  try {
    console.log(`Creating ESTO payment (${selectedPayment}) with data:`, {
      amount: paymentData.amount,
      reference: paymentData.merchantReference,
      customerName: `${paymentData.customerFirstName} ${paymentData.customerLastName}`,
      items: paymentData.lineItems.length
    });
    
    const response = await fetch(`${SUPABASE_URL}/functions/v1/payment`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${SUPABASE_ANON_KEY}`
      },
      body: JSON.stringify({
        orderData: paymentData,
        selectedPayment: selectedPayment,
        isTest
      })
    });

    // Get the response text first for logging
    const responseText = await response.text();
    
    let responseData;
    try {
      // Try to parse as JSON
      responseData = JSON.parse(responseText);
    } catch (parseError) {
      console.error('Invalid JSON response from payment API:', responseText);
      throw new Error(`Invalid response from server: ${responseText.substring(0, 150)}...`);
    }

    if (!response.ok) {
      throw new Error(responseData.message || 'Payment initialization failed');
    }

    console.log('ESTO payment created successfully', {
      paymentUrl: responseData.paymentUrl?.substring(0, 30) + '...',
      reference: responseData.reference
    });
    
    return responseData;
  } catch (error) {
    console.error('Error creating ESTO payment:', error);
    throw error;
  }
}

export async function createManualBankTransfer(paymentData: PaymentRequest) {
  try {
    console.log('Creating manual bank transfer for order:', paymentData.merchantReference);
    
    const response = await fetch(`${SUPABASE_URL}/functions/v1/payment`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${SUPABASE_ANON_KEY}`
      },
      body: JSON.stringify({
        orderData: paymentData,
        selectedPayment: 'manual_transfer'
      })
    });

    // Get the response text first
    const responseText = await response.text();
    
    let responseData;
    try {
      // Try to parse as JSON
      responseData = JSON.parse(responseText);
    } catch (parseError) {
      console.error('Invalid JSON response from payment API:', responseText);
      throw new Error(`Invalid response from server: ${responseText.substring(0, 150)}...`);
    }

    if (!response.ok) {
      throw new Error(responseData.message || 'Payment processing failed');
    }

    return responseData;
  } catch (error) {
    console.error('Error creating manual bank transfer:', error);
    throw error;
  }
}